import script from "./Topbar.vue?vue&type=script&lang=ts&setup=true"
export * from "./Topbar.vue?vue&type=script&lang=ts&setup=true"

import "./Topbar.vue?vue&type=style&index=0&id=0e5b5daa&lang=css"

const __exports__ = script;

export default __exports__